import { render, staticRenderFns } from "./openApproveProviderFree.vue?vue&type=template&id=785f28a4&scoped=true&"
import script from "./openApproveProviderFree.vue?vue&type=script&lang=ts&"
export * from "./openApproveProviderFree.vue?vue&type=script&lang=ts&"
import style0 from "./openApproveProviderFree.vue?vue&type=style&index=0&id=785f28a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f28a4",
  null
  
)

export default component.exports